export type CustomOfferCheckoutPath = 'custom-offer' | 'custom-offer-v2' | 'payment-schedule-balance'
export type CustomOfferV2Type = 'full_payment' | 'payment_schedule' | 'manual' | undefined

function getCustomOfferPaymentMetadata(order?: App.Order): App.CustomOfferPaymentMetadata | undefined {
  return order?.customOfferItems?.[0]?.custom_offer?.payment_metadata
}

export function getCustomOfferCheckoutPath(order?: App.Order): CustomOfferCheckoutPath {
  const paymentMetadata = getCustomOfferPaymentMetadata(order)
  if (paymentMetadata?.payment_flow_version !== 'v2') {
    return 'custom-offer'
  }

  if (
    paymentMetadata.payment_flow_v2?.type === 'payment_schedule' &&
    order?.paymentScheduleDetails?.charges.some(charge => charge.status === 'paid') &&
    order?.paymentScheduleDetails?.charges.some(charge => charge.status === 'pending' || charge.status === 'failed')
  ) {
    return 'payment-schedule-balance'
  }

  return 'custom-offer-v2'
}

export function getCustomOfferV2Type(order?: App.Order): CustomOfferV2Type {
  const paymentMetadata = getCustomOfferPaymentMetadata(order)

  if (paymentMetadata?.payment_flow_version !== 'v2') {
    return
  }

  return paymentMetadata.payment_flow_v2?.type
}

export function getCustomOfferDueDate(order?: App.Order): string | undefined {
  const customOffer = order?.customOfferItems?.[0]?.custom_offer
  const paymentMetadata = customOffer?.payment_metadata

  if (paymentMetadata?.payment_flow_version !== 'v2') {
    return customOffer?.due_date
  }

  const v2 = paymentMetadata.payment_flow_v2
  switch (v2?.type) {
    case 'full_payment':
    case 'payment_schedule':
      return v2.payment_deadline
    case 'manual':
      return v2.manual_balance_due_date
    default:
      return undefined
  }
}

export function buildCustomOfferV2PaymentMetadata(order: App.Order): App.PaymentPlan['payment_metadata'] | undefined {
  const paymentMetadata = getCustomOfferPaymentMetadata(order)
  const v2 = paymentMetadata?.payment_flow_v2

  if (paymentMetadata?.payment_flow_version !== 'v2' || !v2?.type) {
    return undefined
  }

  return {
    payment_flow_version: 'v2',
    payment_flow_v2: {
      type: v2.type,
      deposit_amount: v2.deposit_amount,
      balance_amount: v2.balance_amount,
      balance_due_date: v2.balance_due_date,
    },
  }
}
